import styled from "styled-components";

export const Div = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const InputGroup = styled.div`
  flex: 1 1 45%;
  display: flex;
  flex-direction: column;
  margin: 8px;

  @media (max-width: 768px) {
    flex: 1 1 100%;
  }
`;

export const Label = styled.label`
  margin-bottom: 4px;
`;

export const ButtonGroup = styled.div`
  flex: 1 1 33%;
  display: flex;
  justify-content: flex-start;
  margin: 8px;

  @media (max-width: 768px) {
    flex: 1 1 100%;
    justify-content: center;
  }
`;

export const CompanyListItemContainer = styled.div`
    padding-left:5px;
    padding-right:15px;
`